import type { FieldConfig, ModuleConfig } from './types';

// Every web entry form, for the Administration -> Entry Form Settings
// dropdown. Each page registers its forms when the app loads (pages are
// imported up front), so the list is complete without opening each page.

export interface FormOptionDef {
  key: string;
  label: string;
  help?: string;
  min: number;
  max: number;
  defaultValue: number;
}

export interface FormEntry {
  id: string;
  page: string;
  title: string;
  fields: FieldConfig<any>[];
  /** Form-wide numbers, e.g. the minimum photos on Add Animal. */
  options?: FormOptionDef[];
  /** A hand-built form: only "required" and the form options can be changed. */
  limited?: boolean;
}

const registry = new Map<string, FormEntry>();
/** "Milk Sales / ಹಾಲು ಮಾರಾಟ" -> "Milk Sales"; "Lambing / Kidding" stays as it is. */
export const english = (s: string) => s.replace(/ \/ [^A-Za-z]*[ಀ-೿].*$/, '');

/** Registers a page's forms (read-only lists and forms with no fields are skipped). */
export function registerForms(page: string, ...configs: ModuleConfig<any>[]): void {
  for (const c of configs) {
    if (c.readOnly || c.fields.length === 0) continue;
    registry.set(c.queryKey, { id: c.queryKey, page, title: english(c.title), fields: c.fields });
  }
}

export function registerCustomForm(entry: FormEntry): void {
  registry.set(entry.id, entry);
}

export function listForms(): FormEntry[] {
  return [...registry.values()].sort((a, b) => a.page.localeCompare(b.page) || a.title.localeCompare(b.title));
}
